import { Component, OnInit, EventEmitter,Output } from '@angular/core';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import Swal from 'sweetalert2';
import { MatTableDataSource,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MessagesTitles, MessagesStatus } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { EmpresasService } from '../../../../services/empresas/empresas.service';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-contacto-empresa',
  templateUrl: './contacto-empresa.component.html',
  styleUrls: ['./contacto-empresa.component.scss'],
  providers: [MessagesTitles, MessagesStatus, DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class ContactoEmpresaComponent implements OnInit {
  
  loading: boolean;
  contactos: any= [];

  displayedColumns = ['Nombre_de_Contacto', 'Correo', 'Nro_Documento_Identidad', 'Rol_Del_Contacto_Dsc', 'Des_Condicion']
  dataSource: any;
  
  @Output() cerrarDetalle = new EventEmitter<boolean>();
  @Output() dataDetalle = new EventEmitter<boolean>();

  constructor(private riesgosService : RiesgoService,
              private empresasService :EmpresasService) { }

  ngOnInit() {
    this.obtenerContactoEmpresa();
  }

  obtenerContactoEmpresa() {

    this.loading = true;
    let arrayContacts = this.riesgosService.contactoEmpresa;

    this.empresasService.obtenerContactosEmpresa(arrayContacts.idEmpresa).subscribe(
      res => {
        this.contactos = res;
        this.dataSource = new MatTableDataSource(this.contactos);
        this.loading = false;
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.loading = false;
      }
    );
  }

  CerrarPopUp() {
    this.cerrarDetalle.emit();
  }
}
